import { rootStore } from 'store/root';
import i18next from 'i18next';

const { nxlApi, ipcRenderer } = window;

nxlApi.nexonlinkEvents.sub(async (key: string, data: { toyServiceId: string, deviceName: string }) => {
    const showTrayNoti = (start = true) => {
        const productId = rootStore.appStore.nexonlink.convGidToProductId(data.toyServiceId);
        const product = rootStore.appStore.pc.find((x) => x.productId === productId);
        if (product) {
            ipcRenderer.invoke(
                'showTrayNotification',
                product.name,
                i18next.t(`nexonlink:tray-notice.${start ? 'start' : 'stop'}`),
                rootStore.regionConfig.cdnHost + product.navigationGameIcon,
                productId
            );
        }
    };

    switch (key) {
        case 'onStreamingStarted':
            rootStore.appStore.nexonlink.setStreamingInfo(data.toyServiceId, true);
            showTrayNoti();
            break;
        case 'onStreamingStopped':
            rootStore.appStore.nexonlink.setStreamingInfo(data.toyServiceId, false);
            showTrayNoti(false);
            break;
    };
})
